import React from "react";
import MonthDropdown from "./month";
import YearDropdown from "./year";
import { getValue } from "@utils/lodash";
import moment from "moment";

function CalenderDropdown(props) {
	let month = getValue(props, `value`, "")
		? moment(
				getValue(props, `value`, "") ? getValue(props, `value`, "") : new Date()
		  )
				.format("YYYY-MM-DD")
				.split("-")[1]
		: "";
	let year = getValue(props, `value`, "")
		? moment(
				getValue(props, `value`, "") ? getValue(props, `value`, "") : new Date()
		  )
				.format("YYYY-MM-DD")
				.split("-")[0]
		: "";

	const handleSelectMonth = (value) => {
		if (getValue(value, "value") && year) {
			let date = `${year}-${getValue(value, "value")}-01`;
			props.onChange(new Date(date));
		}
	};

	const handleSelectYear = (value) => {
		if (getValue(value, "value") && year) {
			let date = `${getValue(value, "value")}-${month}-01`;
			props.onChange(new Date(date));
		}
	};

	return (
		<div className="d-flex">
			<MonthDropdown value={month} handleSelectDate={handleSelectMonth} />
			<YearDropdown value={year} handleSelectDate={handleSelectYear} />
			<button className="calender-button" onClick={props.handleSubmitDate}>
				Apply
			</button>
		</div>
	);
}

export default CalenderDropdown;
